import { render, staticRenderFns } from "./FPTemp5.vue?vue&type=template&id=4b26b630&scoped=true&"
import script from "./FPTemp5.vue?vue&type=script&lang=js&"
export * from "./FPTemp5.vue?vue&type=script&lang=js&"
import style0 from "./FPTemp5.vue?vue&type=style&index=0&id=4b26b630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b26b630",
  null
  
)

export default component.exports